import styled, { css } from 'styled-components'
import { xsMd } from '../../theme/utils/media-query'

export function makeFlexContainer (element) {
  return styled(element)`
    display: flex;
    flex-direction: ${props => props.direction};
    height: ${props => props.height || '100%' };
    ${props => props.alignItems && css`
      align-items: ${props.alignItems};
    `}
    ${props => props.justifyContent && css`
      justify-content: ${props.justifyContent};
    `}
    ${props => props.flexGrow && css`
      flex-grow: ${props.flexGrow};
    `}
    ${props => props.flexWrap && css`
      flex-wrap: wrap;
    `}
    ${props => props.flexBasis && css`
      flex-basis: ${props.flexBasis};
    `}
    ${props => props.alignSelf && css`
      align-self: ${props.alignSelf};
    `}
    ${props => props.width && css`
      width: ${props.width};
    `}
    ${props => props.maxWidth && css`
      max-width: ${props.maxWidth};
    `}
    ${props => props.marginTop && css`
      margin-top: ${props.marginTop};
    `}
    ${props => props.marginBottom && css`
      margin-bottom: ${props.marginBottom};
    `}
    ${props => props.marginLeft && css`
      margin-left: ${props.marginLeft};
    `}
    ${props => props.height && css`
      height: ${props.height};
    `}

    ${props => props.mobileWrap && xsMd(css`
      {
        flex-wrap: wrap;
        justify-content: center;
      }
    `)}
  `
}

export default makeFlexContainer